import { useViewport } from './useViewport';

// Adapted from https://stackoverflow.com/a/52854585
export function getCanHover(): boolean | undefined {
  return 'matchMedia' in window ? window.matchMedia?.('(any-hover: hover)').matches : undefined;
}

export function useCanHover(): boolean {
  const { breakpoint } = useViewport();
  const canHover = getCanHover();
  if (canHover != null) return canHover;
  return breakpoint !== 'mobile';
}
